import Box from '@mui/material/Box';
import { PropsWithChildren, ReactNode } from 'react';

interface HeaderProps extends PropsWithChildren {
  title: ReactNode;
}

export function Header({ children, title }: HeaderProps) {
  return (
    <Box
      sx={(theme) => ({
        alignItems: 'center',
        borderBottom: `solid 1px ${theme.palette.divider}`,
        display: 'flex',
        justifyContent: 'space-between',
        p: 2,
      })}
    >
      <Box>{title}</Box>

      <Box>{children}</Box>
    </Box>
  );
}
